import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";
import {
  currencyList,
  languageList,
  languageArray,
} from "../../constants/localization";
import { useTranslation } from "react-i18next";
import LanguageIcon from "../svgs/LanguageIcon";
import ArrowDownIcon from "../svgs/ArrowDownIcon";
import {
  AmazonLink,
  AppStoreLink,
  ContactLink,
  FacebookLink,
  InstagramLink,
  PlayStoreLink,
  PrivacyPolicyLink,
  ShopLink,
  SupportLink,
  TermsOfServiceLink,
  YoutubeLink,
} from "../../utils/links";

var currency = currencyList.GBP;
var language = languageList.en;

function updateLanguage(language) {
  var user_prefs = JSON.parse(localStorage.getItem("user-prefsv2"));
  user_prefs.language = language;
  localStorage.setItem("user-prefsv2", JSON.stringify(user_prefs));
  localStorage.setItem("i18nextLng", language);
  window.location.reload();
}

const Footer = () => {

  const [isWebView, setIsWebView] = useState(false);

    useEffect(() => {
    if (
      window.client === "colla_app" ||
      localStorage.getItem("iscollawebview") === "true"
    )
      setIsWebView(true);
  }, []);

  window.addEventListener("located", () => {
    var user_prefs = JSON.parse(localStorage.getItem("user-prefsv2"));
    setSelectedCur(user_prefs.currency);
    setSelectedLang(
      t("localization.languages." + user_prefs.language)
        ? t("localization.languages." + user_prefs.language)
        : "English",
    );
  });

  const { t } = useTranslation();

  if (localStorage.getItem("user-localev2") != null) {
    var user_prefs = JSON.parse(localStorage.getItem("user-prefsv2"));
    currency = user_prefs.currency;
    language = t("localization.languages." + user_prefs.language)
      ? t("localization.languages." + user_prefs.language)
      : "English";
  }

  const [selectedCur, setSelectedCur] = useState(currency);
  const [selectedLang, setSelectedLang] = useState(language);

  return (
    isWebView ? null : (
    <div className="border-t px-3 w-full flex flex-col items-center justify-center z-[2] relative bg-background bg-opacity-80">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 w-full max-w-sm md:max-w-7xl pt-8 sm:py-12 relative z-[5]">
        <div className="hidden md:flex flex-col items-start gap-2">
          <a
            href={ShopLink}
            target="_blank"
            rel="noopener"
            aria-label="colla Tracking"
          >
            <img
              src="/assets/branding/logo.svg"
              className="h-12 object-contain mx-auto lg:ml-0 hidden md:block"
              alt="logo"
              loading="lazy"
            />
          </a>

          <p className="mt-4 text-text-label font-medium">
            {t("footer.social.title")}
          </p>

          <div className="flex items-center gap-6 mt-2">
            <a
              href={YoutubeLink}
              target="_blank"
              rel="noopener "
              aria-label="Youtube"
            >
              <BsYoutube className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>

            <a
              href={FacebookLink}
              target="_blank"
              rel="noopener "
              aria-label="Facebook"
            >
              <BsFacebook className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>

            <a
              href={InstagramLink}
              target="_blank"
              rel="noopener "
              aria-label="Instagram"
            >
              <BsInstagram className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>
          </div>
        </div>
        <div className="flex flex-col items-start gap-2">
          <p className="font-semibold text-sm text-text-button">
            {t("footer.shop.title")}
          </p>
          <a
            href={AmazonLink}
            target="_blank"
            rel="noopener "
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            Amazon
          </a>
          <a
            href={ShopLink}
            target="_blank"
            rel="noopener "
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            {t("footer.shop.our_shop")}
          </a>
        </div>
        <div className="flex flex-col items-end md:items-start gap-2">
          <p className="font-semibold text-sm text-text-button">
            {t("footer.help.title")}
          </p>
          <Link
            to={SupportLink}
            target="_blank"
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            {t("footer.help.faqs")}
          </Link>
          <Link
            to={ContactLink}
            target="_blank"
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            {t("footer.help.contact")}
          </Link>
        </div>
        <div className="flex flex-col items-start gap-2">
          <p className="font-semibold text-sm text-text-button">
            {t("footer.legal.title")}
          </p>

          <Link
            to={PrivacyPolicyLink}
            target="_blank"
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            {t("footer.help.privacy")}
          </Link>
          <Link
            to={TermsOfServiceLink}
            target="_blank"
            className="text-[#667085] font-medium hover:text-[#475467]"
          >
            {t("footer.help.terms")}
          </Link>
        </div>
        <div className="flex md:hidden flex-col items-end gap-2">
          <p className="text-text-label font-medium">Social Media</p>

          <div className="flex items-center gap-6 mt-2">
            <a
              href={YoutubeLink}
              target="_blank"
              rel="noopener "
              aria-label="Youtube"
            >
              <BsYoutube className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>

            <a
              href={FacebookLink}
              target="_blank"
              rel="noopener "
              aria-label="Facebook"
            >
              <BsFacebook className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>

            <a
              href={InstagramLink}
              target="_blank"
              rel="noopener "
              aria-label="Instagram"
            >
              <BsInstagram className="size-5 cursor-pointer text-text-button hover:text-black transition-all" />
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center md:items-start gap-2 col-span-2 md:col-span-1">
          <p className="font-semibold text-sm text-text-button">
            {t("footer.app.title")}
          </p>
          <div className="flex flex-row md:flex-col gap-3">
            <a
              className=""
              href={AppStoreLink}
              target="_blank"
              rel="noopener "
              aria-label="App Store"
            >
              <img
                src={t("footer.app.appstore")}
                className="h-11 w-auto md:h-auto md:w-36 hvr_hover_opacity"
                alt="app store"
              />
            </a>
            <a
              className=" "
              href={PlayStoreLink}
              target="_blank"
              rel="noopener "
              aria-label="Play Store"
            >
              <img
                src={t("footer.app.playstore")}
                className="h-11 w-auto md:h-auto md:w-36 hvr_hover_opacity"
                alt="play store"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:items-start items-center justify-start pb-22 md:pb-20 py-8 gap-4 w-full max-w-7xl">
        <a href="/success" className="text-sm text-center md:text-left">
          {t("footer.copyright.text")}
        </a>

        <div className="flex items-center gap-6">
          {/*}
          <Dropdown
            label={selectedCur.code}
            items={currencyArray.map((currency, i) => ({
              label: currency.symbol + " " + currency.code,
              onClick: () => {
                setSelectedCur(currency);
                updateCurrency(currency.code);
              },
              isActive: selectedCur.code === currency.code,
            }))}
            icon={() => <CurrencyIcon />}
          />

          <div className="h-4 w-px bg-[#D0D5DD]"></div>
*/}
          <Dropdown
            label={selectedLang}
            items={languageArray.map((language, i) => ({
              label: language.name,
              onClick: () => {
                setSelectedLang(language.name);
                updateLanguage(language.code);
              },
              isActive: selectedLang === language.name,
            }))}
            icon={() => <LanguageIcon />}
          />
        </div>
      </div>

      <img
        className="absolute bottom-0 right-0 h-64 hidden md:block z-[3]"
        src="/assets/illustrations/person-with-dog.svg"
        alt="Person with Dog"
      />
    </div>
  ));
};

const Dropdown = ({ label, items, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  return (
    <div className="relative inline-block text-left " ref={dropdownRef}>
      <button
        type="button"
        className="inline-flex items-center gap-2"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        {icon()}
        <p className="font-semibold">{label}</p>
        <div className={`${isOpen ? "rotate-0" : "rotate-180"}`}>
          <ArrowDownIcon />
        </div>
      </button>

      <div
        className={`absolute ${
          isOpen
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-8 pointer-events-none"
        } bottom-full overflow-hidden transition-all duration-300 left-0 mb-2 w-32 rounded-xl border shadow-md bg-background z-10`}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
        onKeyDown={handleKeyDown}
      >
        <div className="p-2 flex flex-col gap-1" role="none">
          {items.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                item.onClick();
                setIsOpen(false);
              }}
              className={`block w-full text-left px-4 py-2 text-sm rounded-md text-gray-700 hover:bg-gray-100 hover:text-gray-900 ${
                item.isActive && "ring-1 ring-black"
              }`}
              role="menuitem"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Footer;
